/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {FormCheck} from "react-bootstrap";
import React from "react";

export const BooleanEditor = (props) => {
	const {OnUpdate, Value} = props;
	return <FormCheck
		checked={Value}
		onChange={() => {
			OnUpdate(Value ? 0 : 1);
		}}
	/>;
}